module.exports = __webpack_public_path__ + "img/未标题-3-12.3a15ace4.png";